import {
  gql,
  MutationHookOptions,
  OperationVariables,
  useMutation,
} from '@apollo/client';

import { UserSuccessOutput } from './types';

export interface ICreateUser {
  createUser: UserSuccessOutput;
}

export const CREATE_USER = gql`
  mutation createUser($input: CreateUserInput!) {
    createUser(input: $input) {
      status_code
      body {
        data
        message
        success
      }
    }
  }
`;

export const useCreateUser = (
  options: MutationHookOptions<ICreateUser, OperationVariables>,
) => {
  return useMutation<ICreateUser, OperationVariables>(CREATE_USER, options);
};
